import React, { memo } from "react";
import logoimg from '../../assets/logoimg.png';

const Header = () => {
  const isMobile = window.innerWidth <= 640;
  const isTablet = window.innerWidth <= 1024;

  return (
    <header
      style={{
        padding: isMobile ? "20px 10px" : isTablet ? "30px 15px" : "40px 20px",
        textAlign: "center",
        background: "linear-gradient(to right, #0f172a, #1e293b)",
        color: "#f8fafc",
        borderRadius: "26px",
        margin: "0 auto 24px",
        boxShadow: "0 6px 24px rgba(0,0,0,0.4)",
        maxWidth: "100%",
        width: "calc(100% - 40px)",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {/* Flex container centered horizontally and vertically */}
      <div style={{ 
        display: 'flex', 
        gap: isMobile ? '15px' : isTablet ? '20px' : '30px',
        justifyContent: 'center', 
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        
        {/* Logo Container */}
        <div>
          <img 
            src={logoimg} 
            alt="SARLearn Logo"
            style={{
              width: isMobile ? "80px" : isTablet ? "100px" : "120px",
              height: "auto",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
            }}
          />
        </div>

        {/* Text Content Container */}
        <div style={{ 
          textAlign: 'left', 
          minWidth: isMobile ? '100%' : '300px',
          width: isMobile ? '100%' : 'auto'
        }}>
          <h1
            style={{
              fontSize: isMobile ? "1.5rem" : isTablet ? "2rem" : "3rem",
              margin: "0 0 8px 0",
              fontWeight: "800",
              color: "#ffffff",
              letterSpacing: "-1px"
            }}
          >
            SARLearn
          </h1>

          <p
            style={{
              fontSize: isMobile ? "0.85rem" : isTablet ? "0.95rem" : "1.1rem",
              fontWeight: "600",
              margin: "5px 0",
            }}
          >
            <a
              href="https://share.google/23yxfzIiTQCRPc1Gc"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#60a5fa", textDecoration: "none" }}
            >
              📍 Our location
            </a>
          </p>

          <p
            style={{
              fontSize: isMobile ? "0.75rem" : isTablet ? "0.85rem" : "0.95rem",
              fontStyle: "italic",
              color: "#cbd5e1",
              margin: "8px 0 16px 0",
              lineHeight: 1.5,
            }}
          >
            Based in Tamil Nadu | Training Students Worldwide 
            Remote <br/> <span style={{ fontWeight: '800' }}>online</span> and <span style={{ fontWeight: '800' }}>offline</span>  training available in <span style={{ fontWeight: '800' }}>தமிழ்</span> & <span style={{ fontWeight: '800' }}>English.</span>
          </p>

          <div style={{ 
            fontSize: isMobile ? "0.8rem" : isTablet ? "0.9rem" : "1rem",
            fontWeight: "600", 
            display: 'flex', 
            gap: isMobile ? '10px' : '20px',
            flexDirection: isMobile ? 'column' : 'row',
            flexWrap: 'wrap'
          }}>
            <a
              href="mailto:samjose.tutor@gmail.com"
              style={{ color: "#facc15", textDecoration: "none", overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              📧 samjose.tutor@gmail.com
            </a>
            <a
              href="tel:+918248162712"
              style={{ color: "#34d399", textDecoration: "none" }}
            >
              📞 +91-8248162712
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default memo(Header);